import ChartContent from './ChartContent';
import ChartHeader from './ChartHeader';
import ChartRoot from './ChartRoot';
import { ChartProps } from './types';

export * from './types';
export * from './constants';

export default function Chart(props: ChartProps): JSX.Element {
    return (
        <ChartRoot>
            <ChartHeader actions={props.actions} />
            <ChartContent {...props} activeMarkIndex={0} />
        </ChartRoot>
    );
}
